/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let ItemRelatedGroupsImport;
let ItemRelatedGroupsMobileImport;
let RatingsAndReviewsImport;
let RatingsAndReviewsMobileImport;
let FeatureBasedRecommendationsImport;
let CollectionListImport;

/** *********************
 * IRG
 ********************** */
export const ItemRelatedGroupsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "irg-desktop" */
  '@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsDesktop')
  .then((module) => {
    const { ItemRelatedGroupsDesktop } = module;

    ItemRelatedGroupsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <ItemRelatedGroupsDesktop {...props} />
        </QueryProvider>
      );
    };
  });

export const ItemRelatedGroups = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsDesktop')).ItemRelatedGroupsDesktop
  : (props) => <ItemRelatedGroupsImport {...props} />;

export const ItemRelatedGroupsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups/dist/components/dataModel')).dataModel
  : {};

export const ItemRelatedGroupsMobileLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "irg-mobile" */
  '@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsMobile')
  .then((module) => {
    const { ItemRelatedGroupsMobile } = module;

    ItemRelatedGroupsMobileImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <ItemRelatedGroupsMobile {...props} />
        </QueryProvider>
      );
    };
  });

export const ItemRelatedGroupsMobile = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsMobile')).ItemRelatedGroupsMobile
  : (props) => <ItemRelatedGroupsMobileImport {...props} />;

/** *********************
 * FBR
 ********************** */
export const FeatureBasedRecommendationsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "feature-based-recommendations" */
  '@thd-olt-component-react/feature-based-recommendations')
  .then((module) => {
    const { FeatureBasedRecommendations } = module;

    FeatureBasedRecommendationsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <FeatureBasedRecommendations {...props} />
        </QueryProvider>
      );
    };
  });

export const FeatureBasedRecommendations = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations
  : (props) => <FeatureBasedRecommendationsImport {...props} />;

export const FeatureBasedRecommendationsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations.dataModel
  : {};

/** *********************
 * Collection List
 ********************** */
export const CollectionListLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "collection-list" */
  '@thd-olt-component-react/collection-list')
  .then((module) => {
    const { CollectionList } = module;

    CollectionListImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <CollectionList {...props} />
        </QueryProvider>
      );
    };
  });

export const CollectionList = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/collection-list')).CollectionList
  : (props) => <CollectionListImport {...props} />;

export const CollectionListModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/collection-list')).CollectionList.dataModel
  : {};

/** *********************
 * Ratings and Reviews
 ********************** */
export const RatingsAndReviewsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews-desktop" */
  '@thd-olt-component-react/ratings-and-reviews/dist/component/RatingsAndReviewsDesktop')
  .then((module) => {
    const { RatingsAndReviewsDesktop } = module;

    RatingsAndReviewsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <RatingsAndReviewsDesktop {...props} />
        </QueryProvider>
      );
    };
  });

export const RatingsAndReviews = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews/dist/component/RatingsAndReviewsDesktop')).RatingsAndReviewsDesktop
  : (props) => <RatingsAndReviewsImport {...props} />;

export const RatingsAndReviewsMobileLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews-mobile" */
  '@thd-olt-component-react/ratings-and-reviews/dist/component/RatingsAndReviewsMobile')
  .then((module) => {
    const { RatingsAndReviewsMobile } = module;

    RatingsAndReviewsMobileImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <RatingsAndReviewsMobile {...props} />
        </QueryProvider>
      );
    };
  });

export const RatingsAndReviewsMobile = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews/dist/component/RatingsAndReviewsMobile')).RatingsAndReviewsMobile
  : (props) => <RatingsAndReviewsMobileImport {...props} />;

export const RatingsAndReviewsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews/dist/component/ReviewDataModel')).dataModel
  : {};
